import { render, staticRenderFns } from "./appointmentDetails.vue?vue&type=template&id=47a56b34&scoped=true"
import script from "./appointmentDetails.vue?vue&type=script&lang=js"
export * from "./appointmentDetails.vue?vue&type=script&lang=js"
import style0 from "./appointmentDetails.vue?vue&type=style&index=0&id=47a56b34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a56b34",
  null
  
)

export default component.exports